<template>
  <div class="programme">
    <common :title="'方案分布（单个方案）'"></common>
    <ul class="programme_list" v-if="list.length > 0">
      <li v-for="(item, index) in list" :key="index">
        <div>
          <span>{{ item.key }} :</span> <span>{{ item.num }}条</span>
        </div>
        <div @click="detailsClick(item.key)">
          查看 >
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import common from './common.vue';
import { warningScheme } from '@/api/index'
import moment from 'moment';
import { geturl } from '@/utils/index';
export default {
  name: 'programme',
  components: {
    common
  },
  data() {
    return {
      list: []

    }
  },
  mounted() {
    let params = geturl()
    if (params && params.openId) {
      const id = params.openId
      localStorage.setItem('id', id);
    }
    this.getlist()
  },
  methods: {
    moment,
    getlist() {
      // 获取当日开始时间和结束时间时间戳
      // 获取近7天的数据
      let endTime = moment().endOf('day').valueOf();
      let startTime = moment().subtract(7, 'days').startOf('day').valueOf();
      let data = {
        start: startTime,
        end: endTime,
        openId: localStorage.getItem('id')
      }
      warningScheme(data).then(res => {
        this.list = res.topicStatistics
        console.log(this.list);
      })
    },
    detailsClick(key) {
      // 跳转到详情页并传递当前时间 YYYY年M月D日
      this.$router.push({
        path: '/details',
        query: {
          topicName: key
        }
      })
    },
  }
}
</script>
 
<style lang = "less" scoped>
.programme {
  padding: .1rem;
  background: #fff;

  .programme_list {
    list-style: none;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      padding: .1rem 0;
      border-bottom: 1px solid #efe8cb;
    }
  }
}
</style>